"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-nine/sections/healthSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type HealthSectionContentsItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/about/health-03.jpg" | "/Templates/Doccure/img/about/health-04.jpg" | "/Templates/Doccure/img/about/health-05.jpg" */
    src: string;
    /** Detected variants: "content-img" */
    className?: string;
    /** Detected variants: "content-img-single" */
    div0ClassName?: string;
    /** Detected variants: "health" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
};
export type HomeNineHealthSectionGeneratedProps = {
    divDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: HealthSectionContentsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    /** Default: "Caring Hands, Healing at Home." */
    sectionDiv0Div0DivText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    /** Default: "Professional healthcare, nursing, and elder care services delivered to your doorstep safe, compassionate, and personalized." */
    sectionDiv0Div1Div0Div3H20H2Text?: ReactNode;
    sectionDiv0Div1Div0Div3H20H2Visible?: boolean;
    sectionDiv0Div1Div0Div3H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Div3H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "callto:" */
    sectionDiv0Div2Div0Div1Link0LinkHref?: string;
    /** Default: "+1 24565 89856" */
    sectionDiv0Div2Div0Div1Link0LinkText?: ReactNode;
    sectionDiv0Div2Div0Div1Link0LinkVisible?: boolean;
    sectionDiv0Div2Div0Div1Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div2Div0Div1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Call Us" */
    sectionDiv0Div2Div0Div1Span0SpanText?: ReactNode;
    /** Default: "health" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/health-img.svg" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    healthSectionContents: HealthSectionContentsItem[];
    healthSectionContentsItemWrapper?: (item: HealthSectionContentsItem, content: ReactNode) => ReactNode;
    healthSectionContentsRenderer?: (defaultNode: ReactNode) => ReactNode;
    healthSectionContentsImageVisible?: boolean;
    healthSectionContentsImageRenderer?: (item: HealthSectionContentsItem, defaultNode: ReactNode) => ReactNode;
    healthSectionContentsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: HealthSectionContentsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
};

const HomeNineHealthSectionGenerated: FC<HomeNineHealthSectionGeneratedProps> = ({
    sectionDiv0Div0DivText = "Caring Hands, Healing at Home.",
    sectionDiv0Div1Div0Div3H20H2Text = "Professional healthcare, nursing, and elder care services delivered to your doorstep safe, compassionate, and personalized.",
    sectionDiv0Div1Div0Div3H20H2Visible,
    sectionDiv0Div1Div0Div3H20H2Renderer,
    sectionDiv0Div1Div0Div3H20H2Props,
    sectionDiv0Div2Div0Div1Link0LinkHref = "callto:",
    sectionDiv0Div2Div0Div1Link0LinkText = "+1 24565 89856",
    sectionDiv0Div2Div0Div1Link0LinkVisible,
    sectionDiv0Div2Div0Div1Link0LinkRenderer,
    sectionDiv0Div2Div0Div1Link0LinkProps,
    sectionDiv0Div2Div0Div1Span0SpanText = "Call Us",
    sectionImageWithBasePath0ImageAlt = "health",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/health-img.svg",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divDiv0ImageWithBasePath0ImageProps,
    sectionDiv0Div1ClassName,
    healthSectionContents,
    healthSectionContentsItemWrapper,
    healthSectionContentsRenderer,
    healthSectionContentsImageVisible,
    healthSectionContentsImageRenderer,
    healthSectionContentsImageProps,
}) => {
    return (
        <section className="section health-section health-nine trail-content">
            <div className="container">
                <div className="title">{sectionDiv0Div0DivText}</div>
                <div className={sectionDiv0Div1ClassName ?? "row"}>
                    <div className="col-lg-10 mx-auto">
                        {renderCollectionNode(
                            healthSectionContents,
                            (item: HealthSectionContentsItem) => (
                                <div className={item.className ?? "content-img"} key={item.key}>
                                    <div className={item.div0ClassName ?? "content-img-single"}>
                                        {renderItemNode(healthSectionContentsImageVisible, healthSectionContentsImageRenderer, item, (
                                            <SmartImage src={item.src} className={item.imageWithBasePath0ClassName ?? "img-fluid"} alt={item.alt ?? "health"} {...(typeof healthSectionContentsImageProps === "function" ? healthSectionContentsImageProps(item) : (healthSectionContentsImageProps ?? {}))} {...(typeof divDiv0ImageWithBasePath0ImageProps === "function" ? divDiv0ImageWithBasePath0ImageProps(item) : (divDiv0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                </div>
                            ),
                            healthSectionContentsItemWrapper,
                            healthSectionContentsRenderer
                        )}
                        <div className="health-content">
                            {renderNode(sectionDiv0Div1Div0Div3H20H2Visible, sectionDiv0Div1Div0Div3H20H2Renderer, (
                                <h2 {...(sectionDiv0Div1Div0Div3H20H2Props ?? {})}>{sectionDiv0Div1Div0Div3H20H2Text}</h2>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="text-center view-all">
                    <div className="support-item-list">
                        <div className="support-item-icon">
                            <i className="isax isax-call"></i>
                        </div>
                        <div className="support-item-content">
                            <span className="support-title">{sectionDiv0Div2Div0Div1Span0SpanText}</span>
                            {renderNode(sectionDiv0Div2Div0Div1Link0LinkVisible, sectionDiv0Div2Div0Div1Link0LinkRenderer, (
                                <SmartLink href={sectionDiv0Div2Div0Div1Link0LinkHref} className="link" {...(sectionDiv0Div2Div0Div1Link0LinkProps ?? {})}>{sectionDiv0Div2Div0Div1Link0LinkText}</SmartLink>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid health-img-one" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeNineHealthSectionGenerated;
